module.exports = __webpack_public_path__ + "media/images/logo-altfee-81a892eaec16ea5cbd4da6c0ecd7c7f4.svg";